
export const API_BASE_URL = (process.env.VUE_APP_URL || 'http://localhost:3000').replace(/\/+$/, '')

function getAuthHeaders() {
  const token = JSON.parse(localStorage.getItem('access_token'))
  const headers = {
    'Content-Type': 'application/json',
  }
  if (token) {
    headers['Authorization'] = `Bearer ${token}`
  }
  return headers
}

function handleResponse(response) {
  if (!response.ok) {
    return response.json().then(err => {
      throw err
    })
  }
  return response.json()
}

async function safeFetch(input, init) {
  try {
    const res = await fetch(input, init)
    return handleResponse(res)
  } catch (err) {
    const url = (input && input.href) || input || ''
    console.error('[tenderApi] Network fetch failed for', url, err)
    throw { error: 'Network Error', message: `Failed to fetch ${url}: ${err?.message || err}` }
  }
}

export const tenderApi = {
  // Public endpoints
  getPublicTenders: (params) => {
    const url = new URL(API_BASE_URL + '/tender/public')
    if (params) Object.keys(params).forEach(key => {
      const v = params[key]
      if (v !== undefined && v !== null && v !== '') url.searchParams.append(key, params[key])
    })
    return safeFetch(url, {
      headers: getAuthHeaders(),
    })
  },

  getTenderBySlug: (slug) => {
    return safeFetch(`${API_BASE_URL}/tender/public/${slug}`, {
      headers: getAuthHeaders(),
    })
  },

  submitApplication: (slug, applicationData) => {
    return safeFetch(`${API_BASE_URL}/tender/public/${slug}/submit`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify(applicationData),
    })
  },

  // Admin endpoints
  createTender: (tenderData) => {
    return safeFetch(`${API_BASE_URL}/tender`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify(tenderData),
    })
  },

  getAllTenders: (params) => {
    const url = new URL(API_BASE_URL + '/tender')
    if (params) Object.keys(params).forEach(key => {
      const v = params[key]
      if (v !== undefined && v !== null && v !== '') url.searchParams.append(key, params[key])
    })
    return safeFetch(url, {
      headers: getAuthHeaders(),
    })
  },

  getTender: (id) => {
    return safeFetch(`${API_BASE_URL}/tender/${id}`, {
      headers: getAuthHeaders(),
    })
  },

  getTenderItems: (id) => {
    return safeFetch(`${API_BASE_URL}/tender/${id}/items`, {
      headers: getAuthHeaders(),
    })
  },
  getTenderItemsWithAvailability: (id) => {
    return safeFetch(`${API_BASE_URL}/tender/${id}/items/availability`, {
      headers: getAuthHeaders(),
    })
  },

  updateTender: (id, updateData) => {
    return safeFetch(`${API_BASE_URL}/tender/${id}`, {
      method: 'PUT',
      headers: getAuthHeaders(),
      body: JSON.stringify(updateData),
    })
  },

  deleteTender: (id) => {
    return safeFetch(`${API_BASE_URL}/tender/${id}`, {
      method: 'DELETE',
      headers: getAuthHeaders(),
    })
  },

  publishTender: (id) => {
    return safeFetch(`${API_BASE_URL}/tender/${id}/publish`, {
      method: 'PUT',
      headers: getAuthHeaders(),
    })
  },

  getStats: () => {
    return safeFetch(`${API_BASE_URL}/tender/stats`, {
      headers: getAuthHeaders(),
    })
  },

  getTenderSubmissions: (tenderId, params) => {
    const url = new URL(`${API_BASE_URL}/tender/${tenderId}/submissions`)
    if (params) Object.keys(params).forEach(key => {
      const v = params[key]
      if (v !== undefined && v !== null && v !== '') url.searchParams.append(key, params[key])
    })
    return safeFetch(url, {
      headers: getAuthHeaders(),
    })
  },

  getAllSubmissions: (params) => {
    const url = new URL(`${API_BASE_URL}/tender/submissions`)
    if (params) Object.keys(params).forEach(key => {
      const v = params[key]
      if (v !== undefined && v !== null && v !== '') url.searchParams.append(key, params[key])
    })
    return safeFetch(url, {
      headers: getAuthHeaders(),
    })
  },

  getSubmission: (submissionId) => {
    return safeFetch(`${API_BASE_URL}/tender/submission/${submissionId}`, {
      headers: getAuthHeaders(),
    })
  },

  updateSubmissionStatus: (submissionId, statusData) => {
    return safeFetch(`${API_BASE_URL}/tender/submission/${submissionId}/status`, {
      method: 'PUT',
      headers: getAuthHeaders(),
      body: JSON.stringify(statusData),
    })
  },

  allowSubmissionResubmission: (submissionId, allow = true) => {
    return safeFetch(`${API_BASE_URL}/tender/submission/${submissionId}/allow-resubmission`, {
      method: 'PUT',
      headers: getAuthHeaders(),
      body: JSON.stringify({ allow }),
    })
  },

  evaluateSubmission: (submissionId, evaluationData) => {
    return safeFetch(`${API_BASE_URL}/tender/submission/${submissionId}/evaluate`, {
      method: 'PUT',
      headers: getAuthHeaders(),
      body: JSON.stringify(evaluationData),
    })
  },
}

export default tenderApi